module.exports = __webpack_public_path__ + "img/portrait-044.835d0b67.jpg";